const initialState = "0"; // "0" signifie "Tout"

function selectedEstablishmentReducer(state = initialState, action) {
  switch (action.type) {
    case "selectedEstablishment/update":
      return action.payload;
    default:
      return state;
  }
}

export default selectedEstablishmentReducer;
